export type FormattedJson = { code: string; invalid: boolean };

const PRETTY_INDENT = 2;
const EMPTY: FormattedJson = { code: '', invalid: false };

const pretty = (value: unknown): string =>
  JSON.stringify(value, null, PRETTY_INDENT);

/**
 * Normalize any value into a pretty-printed JSON string.
 * Returns invalid=true when the input looked like JSON but could not be parsed,
 * so the caller can highlight it as an error.
 */
export const formatJson = (raw: unknown): FormattedJson => {
  if (raw === null || raw === undefined || raw === '') {
    return EMPTY;
  }

  // Already-parsed value — stringify directly. Circular refs throw.
  if (typeof raw === 'object') {
    try {
      return { code: pretty(raw), invalid: false };
    } catch {
      return { code: String(raw), invalid: true };
    }
  }

  // String input — parse then re-format so output is always pretty-printed.
  if (typeof raw === 'string') {
    try {
      return { code: pretty(JSON.parse(raw)), invalid: false };
    } catch {
      return { code: raw, invalid: true };
    }
  }

  // Primitives (number, boolean) — display verbatim.
  return { code: String(raw), invalid: false };
};
